/**
 * Search contracts — DESIGN.md §12.4.
 *
 * "`GET /search?q=` runs three ranked queries: tasks … projects (name),
 * comments (`body_text` FTS, returned with their card). Global ⌘K palette
 * consumes it."
 */
import { z } from 'zod';
import { SEARCH_OPERATORS } from '../domain/search-query.js';
import { uuidSchema } from './common.js';
import { projectRefSchema } from './projects.js';
import { taskRefSchema } from './tasks.js';
import { userRefSchema } from './users.js';
export const commentHitSchema = z.object({
    id: uuidSchema,
    task: taskRefSchema,
    author: userRefSchema,
    snippet: z.string(),
    createdAt: z.string(),
});
/**
 * What the server made of the query — echoed back so ⌘K can show the user
 * which operators it understood, and which words it treated as text (R43's
 * "unknown operators degrade to plain text" is invisible otherwise).
 */
export const searchInterpretationSchema = z.object({
    text: z.string(),
    terms: z.array(z.object({
        operator: z.enum(SEARCH_OPERATORS),
        value: z.string(),
        negated: z.boolean(),
        /** False when a name could not be resolved — shown as a hint, not an error. */
        resolved: z.boolean(),
    })),
});
export const searchResultsSchema = z.object({
    /** Set when the query was an exact `#number` — §12.4 short-circuits to it. */
    exactCard: taskRefSchema.nullable(),
    tasks: z.array(taskRefSchema),
    projects: z.array(projectRefSchema),
    comments: z.array(commentHitSchema),
    interpretation: searchInterpretationSchema,
});
export const searchQuerySchema = z.object({
    q: z.string().trim().max(500),
    limit: z.coerce.number().int().min(1).max(50).default(10),
});
//# sourceMappingURL=search.js.map